export function getProposalsForSelection(
  pgConfig,
  activeDistrictType,
  stateAbb = null,
) {
  // 1) Filter by district type (strip 'jurisdiction' tag to avoid false 'sd' matches)
  const afterDistrictType = pgConfig.filter((proposal) => {
    const tags = (proposal?.tags ?? "").replace("jurisdiction", "");
    return tags.includes(activeDistrictType);
  });

  // 2) For 'cd', optionally narrow by state when a valid abbreviation is provided
  let filtered = afterDistrictType;
  if (activeDistrictType === "cd" && stateAbb) {
    filtered = afterDistrictType.filter((proposal) => {
      if (!proposal.state || proposal.state.includes("NULL")) return true;
      return proposal.state.toLowerCase().includes(stateAbb);
    });
  }

  const sort = filtered.sort((a, b) => a.id - b.id)

  return JSON.parse(JSON.stringify(sort));
}
